import React, { useEffect, useRef, useState } from "react";
import { Link, useLocation, useParams } from "react-router-dom";
import FireOnMenu from "./FireOnMenu";
import DashboardMenu from "./DashboardMenu";
import { apiWrapper } from "../../apis/CommonApi";
import * as fireonApi from "../../apis/FireOnApi";
import { dateFormat, getTime } from "../../utils/date";
import PageHeader from "../PageHeader";

export default function FireAlarmSmsLogComponent() {
  const itemsPerPage = 100;
  const { id } = useParams();
  const location = useLocation();
  const { buildingName } = location.state;
  const [dataSource, setDataSource] = useState([]);
  const [page, setPage] = useState(1);
  const [next, setNext] = useState(null);
  const scrollRef = useRef();
  const pageRef = useRef(page);
  const nextRef = useRef(next);


  useEffect(() => {
    const scrollWrap = scrollRef.current;

    const handleScroll = () => {
      if (scrollWrap.scrollTop + scrollWrap.clientHeight >= scrollWrap.scrollHeight - 5) {
        if (nextRef.current) {
          getData(pageRef.current + 1);
        }
      }
    }

    scrollWrap.addEventListener('scroll', handleScroll);

    getData(page);

    return () => {
      scrollWrap.removeEventListener('scroll', handleScroll);
    }
  }, []);

  useEffect(() => {
    pageRef.current = page;
  }, [page]);

  useEffect(() => {
    nextRef.current = next;
  }, [next]);

  const getData = (page) => {
    apiWrapper(async () => {
      const result = await fireonApi.getFireAlarmSmsHistoryList(
        id,
        "",
        "",
        "",
        page,
        itemsPerPage,
      );

      const { status, data } = result;
      if (status === true) {
        setDataSource((prevDataSource) => {
          if (prevDataSource.some(item => item.page === page)) {
            return prevDataSource;
          }

          return [
            ...prevDataSource,
            {
              page: page,
              results: data.results,
            }
          ]
        });

        setNext(data.next);
        setPage(page);
      } else {
        alert(`${data}`);
      }
    });
  }

  return (
    <section id="darkMode" class="mbSection darkMode">
      <PageHeader isBlack={true} title={buildingName} isUseMenu={true} />
      <div class="container">
        <p class="tableTitle mt-24">화재경보 SMS 알림 이력</p>
        <div class="tableList FSLlist">
          <div ref={scrollRef} class="config-row-wrap scroll-wrap type-273">
            {dataSource &&
              dataSource.length > 0 &&
              dataSource.map((pageItem) => {
                if (pageItem.results.length > 0) {
                  return pageItem.results.map((item, index) => (
                    <Link class="config-row" to="">
                      <div class="sms-datetime">
                        <p class="datetime-txt">
                          {dateFormat(new Date(item.eventTime))}
                        </p>
                        <p class="datetime-txt">
                          {getTime(new Date(item.eventTime))}
                        </p>
                      </div>
                      <div class="sms-cont">
                        <p class="cont-txt">{item.description}</p>
                      </div>
                    </Link>
                  ))
                }
              })}
          </div>
        </div>
      </div>
      <div id="dashboardMenu">
        <DashboardMenu buildingName={buildingName} />
      </div>
      <FireOnMenu />
    </section>
  );
}
